import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { NgbModule, NgbDateAdapter, NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { NgxWebstorageModule } from 'ngx-webstorage';

import { AppRoutingModule } from './app-routing.module';
import { FontawesomeModule } from './fontawesome/fontawesome.module';
import { HeaderModule } from './header/header.module';
import { SharedModule } from './shared/shared.module';

import { AppComponent } from './app.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { ChargifyInvoiceConfirmComponent } from './chargify/chargify-invoice-confirm/chargify-invoice-confirm.component';

@NgModule({
  declarations: [
    AppComponent,
    SidebarComponent,
    ChargifyInvoiceConfirmComponent
  ],
  imports: [
    BrowserModule, BrowserAnimationsModule,
    HttpClientModule,
    NgbModule,
    NgxWebstorageModule.forRoot({
      prefix: 'cr_cama',
      separator: '-'
    }),
    AppRoutingModule,
    FontawesomeModule,
    HeaderModule,
    SharedModule
  ],
  providers: [{
    provide: NgbDateAdapter,
    useClass: NgbDateNativeAdapter
  }],
  bootstrap: [AppComponent]
})
export class AppModule { }
